// extracted by mini-css-extract-plugin
export var alertIcon = "_pn-0";